import { SET_SELECTED_ANSWERS } from '../actions/selctedSurveyAction';

const initialState = {
  selectedAnswers: [],
};

export function selectedSurveyReducer (state = initialState, action) {
  switch (action.type) {    
    case SET_SELECTED_ANSWERS:
      return {
        ...state,
        selectedAnswers: action.payload,
      };
    default:
      return state;
  }
}

